/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 * @flow
 */

import React from 'react';
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { Router, Switch, Route } from 'react-router-dom'

import Splash from './components/Splash'
import Screen from './components/Screen.js'
import About from './components/About.js'
import Login from './components/Login.js'
import Menu from "./components/Menu"
import Settings from "./components/Settings"
import News from "./components/News"
import cssAnimations from './actions/cssAnimations'

class App extends React.Component {
  constructor(props) {
    super(props);

    window.addEventListener('DOMContentLoaded', this.domContentLoadedHandler.bind(this));
    document.addEventListener('deviceready', this.onDeviceReadyHandler.bind(this)); // only for mobile
  }

  domContentLoadedHandler() {

    /* rewrites dev.mediajackagency links to redux friendly links @jkr */
    window.moderateATags = (event) => {
      const ele = event.target;
      if (ele.href.indexOf("dev.mediajackagency") > -1) {
        event.preventDefault();

        const match = ele.href.match(/.+\/screen\/([a-z0-9_-]+)\/?/);
        const screen = match[1];

        this.props.dispatch(cssAnimations.reset());

        // setTimeout(() => {
        this.props.history.push(screen);
        // }, 300)
      }
    };

    // font fix @jkr
    if (document.fonts.status === "loading") {
      document.fonts.ready.then(() => {
        const href = window.location.href;
        if (href.indexOf("cordova-ff") <= 0) {
          window.location.href = window.location.href + "#cordova-ff=1"
        }
      });
    }
  }

  onDeviceReadyHandler(event) {

    if (window.cordova) {
      if (navigator.splashscreen) navigator.splashscreen.hide();
      if (window.StatusBar) window.StatusBar.styleDefault();
    }

  }

  componentDidUpdate() { }

  render() {

    return (
      <div id="app" className={this.props._store.cssAnimations.className}>
        <Splash />
        <Menu />
        <div id="router">
          <Router history={this.props.history}>
            <Switch>
              <Route exact path="/screen/:id" component={Screen} />
              <Route exact path="/about" component={About} />
              <Route exact path="/News" component={News} />
              <Route exact path="/settings" component={Settings} />
              <Route component={Login} />
            </Switch>
          </Router>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return ({
    _store: state
  });
}

export default withRouter(connect(mapStateToProps)(App));